import {
  IonButton,
  IonInput,
  IonLabel,
  IonTextarea,
  IonSelectOption,
  IonSelect,
} from "@ionic/react";
import { useEffect, useRef, useState } from "react";

import { GetLatestSetUpEpisode } from "../../services/AuthServices";

interface Props {
  setChooseEpisode?: (value: boolean) => void;
  episodeName?: string;
  rtmStartDate?: string;
  onClose?: () => void;
  setNewEpisode?: (value: boolean) => void;
  isOpen?: boolean;
}

const ChooseEpisodeModal: React.FC<Props> = ({
  onClose,
  rtmStartDate,
  setChooseEpisode,
  setNewEpisode,
  isOpen,
}) => {
  const [episodeName, setEpisodeName] = useState<string>("");
  const customHeightRef = useRef<HTMLDivElement>(null);
  const [spacerHeight, setSpacerHeight] = useState<number>(0);

  const fetchLatestSetupEpisode = async () => {
    try {
      var patientId = localStorage.getItem("patientServerID") || "";
      const response = await GetLatestSetUpEpisode({ patientId });
      const data = response?.data;

      if (data !== null && data !== undefined) {
        setEpisodeName(data?.episodeName || "");
      } else {
        setEpisodeName("");
      }
    } catch (error) {
      console.error("Error fetching latest setup episode:", error);
      setEpisodeName("");
    }
  };

  useEffect(() => {
    if (isOpen) {
      fetchLatestSetupEpisode();
    }
  }, [isOpen]);

  useEffect(() => {
    const el = customHeightRef.current;
    if (!el) return;

    const updateHeight = () => setSpacerHeight(el.offsetHeight);
    updateHeight();

    const observer = new ResizeObserver(updateHeight);
    observer.observe(el);
    return () => observer.disconnect();
  }, []);

  const handleUseCurrentEpisode = () => {
    if (onClose) {
      onClose();
    }
  };

  const handleSetupNewEpisode = () => {
    if (setChooseEpisode) {
      setChooseEpisode(false);
    }
    if (setNewEpisode) {
      setNewEpisode(true);
    }
  };
  return (
    <div className="setup-episode-modal-inner-wrap-sec">
      <h1 className="fz-32 fw-700 align-center text-charcoal-blue mb-16">
        Choose Episode for RTM
      </h1>
      <h1 className="fz-20 fw-400 align-center text-charcoal-blue mb-24">
        Continue with the current episode or create a new episode for this RTM
        cycle
      </h1>

      <div className="choose-episode-cards-wrap">
        {/* Continue with Current Episode Section */}
        <div className="choose-episode-card">
          <div className="card-info-sec">
            <h1 className="fz-24 fw-600 text-charcoal-blue mb-12 align-center">
              Continue with Current Episode
            </h1>
            <h1 className="fz-16 fw-400 text-charcoal-blue mb-16 align-center">
              Uses the existing RTM start date.
            </h1>
            <div className="custom-height" ref={customHeightRef}>
              <div className="choose-episode-row start mb-8">
                <span className="fz-16 fw-400 text-charcoal-blue choose-episode-label">
                  RTM Start Date
                </span>
                <span className="fz-16 fw-600 text-charcoal-blue choose-episode-value">
                  {rtmStartDate || "00/00/0000"}
                </span>
              </div>
              <div className="choose-episode-row start mb-16">
                <span className="fz-16 fw-400 text-charcoal-blue choose-episode-label">
                  Episode Name
                </span>
                <span className="fz-16 fw-600 text-charcoal-blue choose-episode-value">
                  {rtmStartDate} - {episodeName || "Fall Prevention Program"}
                </span>
              </div>
            </div>
          </div>
          <IonButton
            placeholder="undefined"
            className="blue-btn h-44 fz-20 episode-bottom-btn"
            onClick={handleUseCurrentEpisode}
          >
            Use Current Episode
          </IonButton>
        </div>

        {/* Set Up New Episode Section */}
        <div className="choose-episode-card">
          <div className="card-info-sec">
            <h1 className="fz-24 fw-600 text-charcoal-blue mb-12 text-center">
              Set Up New Episode
            </h1>
            <h1 className="fz-16 fw-400 text-charcoal-blue mb-16 align-center">
              Requires choose a new RTM start date.
            </h1>
          </div>
          <IonButton
            placeholder="undefined"
            className="blue-btn h-44 fz-20 episode-bottom-btn"
            onClick={handleSetupNewEpisode}
          >
            Set up New Episode
          </IonButton>
        </div>
      </div>
    </div>
  );
};

export default ChooseEpisodeModal;
